// PG
export const defaultJson = [
  {
    stepId: 'Course Details',
    stepName: 'Course Details',
    showStepName: false,
    stepVisible: true,
    stepPosition: 0,
    stepType: 'form',
    sections: [
      {
        apiKeyId: 'application',
        sectionId: 'ProgramDetails2',
        sectionName: 'Course Details',
        subSectionName: '',
        showSectionName: false,
        sectionPosition: 2,
        sectionVisible: true,
        sectionHelp: '',
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[programName]',
            name: 'application[programName]',
            label: 'Program',
            type: 'input',
            options: [],
            disabled: true,
            apiKey: 'Program',
            validationType: 'string',
            validations: [],
            ui: {
              gridType: 'halfRow',
            },
          },
          {
            fieldId: 'application[academicYear]',
            name: 'application[academicYear]',
            label: 'Academic Cycle',
            type: 'input',
            apiKey: 'application[academicYear]',
            validations: [],
            disabled: true,
            ui: {
              gridType: 'halfRow',
            },
          },
          {
            fieldId: 'application[moreThan3YearExperience]',
            name: 'application[moreThan3YearExperience]',
            label: 'Do you have three years of work experience?',
            type: 'select',
            validations: {
              required: 'This field is required',
            },
            required: true,
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            ui: {
              gridType: 'halfRow',
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'basic Details',
    stepName: 'Basic Details',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        sectionName: 'Basic Details',
        apiKeyId: 'applicant',
        subSectionName: '',
        sectionPosition: 1,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'applicant[firstName]',
            required: true,
            name: 'applicant[firstName]',
            label: 'First Name',
            type: 'input',
            validationType: 'alpha',
            disabled: true,
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid First Name',
              },
              maxLength: {
                value: 40,
                message: 'This field cannot be more than 40 characters',
              },
            },
          },
          {
            fieldId: 'applicant[middleName]',
            name: 'applicant[middleName]',
            label: 'Middle Name',
            disabled: true,
            type: 'input',
            validationType: 'alpha',
            validations: {
              pattern: {
                value: '',
                message: 'Please Input a valid First Name',
              },
              maxLength: {
                value: 40,
                message: 'This field cannot be more than 40 characters',
              },
            },
          },
          {
            fieldId: 'applicant[lastName]',
            required: true,
            name: 'applicant[lastName]',
            label: 'Last Name',
            disabled: true,
            validationType: 'lastName',
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid Last Name',
              },
              maxLength: {
                value: 40,
                message: 'This field cannot be more than 40 characters',
              },
            },
          },
          {
            fieldId: 'applicant[dateOfBirth]',
            required: true,
            name: 'applicant[dateOfBirth]',
            label: 'Date of Birth',
            type: 'date',
            format: 'YYYY-MM-DD',
            validations: {
              required: 'This field is required',
            },
            maxDate: -16,
          },
          {
            fieldId: 'applicant[gender]',
            required: true,
            name: 'applicant[gender]',
            label: 'Gender',
            type: 'select',
            options: [
              {
                value: 'Female',
                label: 'Female',
              },
              {
                value: 'Male',
                label: 'Male',
              },
              {
                value: 'Decline to State',
                label: 'Decline to State',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'applicant[genderIdentity]',
            required: true,
            name: 'applicant[genderIdentity]',
            label: 'Gender Identity',
            type: 'select',
            options: [
              {
                value: 'Male',
                label: 'Male',
              },
              {
                value: 'Female',
                label: 'Female',
              },
              {
                value: 'Nonbinary',
                label: 'Nonbinary',
              },
              {
                value: 'Not Listed',
                label: 'Not Listed',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'applicant[pronouns]',
            required: true,
            name: 'applicant[pronouns]',
            label: 'Gender Pronouns',
            type: 'select',
            options: [
              {
                value: 'He',
                label: 'He',
              },
              {
                value: 'She',
                label: 'She',
              },
              {
                value: 'They',
                label: 'They',
              },
              {
                value: 'Prefer not to say',
                label: 'Prefer not to say',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'applicant[nationality]',
            required: true,
            name: 'applicant[nationality]',
            label: 'Nationality',
            type: 'select',
            metaData: {
              optionsKey: 'nationality',
            },
            options: [],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'applicant[phone]',
            required: true,
            name: 'applicant[phone]',
            label: 'Phone Number',
            type: 'phone',
            apiKey: 'applicant[phone]',
            disabled: true,
            validations: {
              required: 'This field is required',
              pattern: {
                value: {},
                message: 'Please Input a valid Phone Number',
              },
            },
          },
          {
            fieldId: 'applicant[email]',
            required: true,
            name: 'applicant[email]',
            label: 'Email',
            disabled: true,
            type: 'input',
            validationType: 'email',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid Email',
              },
            },
          },
          {
            name: 'applicant',
            type: 'address',
            options: [
              {
                fieldId: 'birthPlace',
                required: true,
                name: 'birthPlace',
                label: 'Country of birth',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
            ],
          },
          {
            fieldId: 'applicant[passportNumber]',
            name: 'applicant[passportNumber]',
            label: 'Passport number',
            validationType: 'alphaNumeric',
            type: 'input',
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid passport number',
              },
              maxLength: {
                message: 'This field cannot be more than 9 characters',
                value: 9,
              },
              minLength: {
                message: 'This field cannot be less than 6 characters',
                value: 6,
              },
            },
          },
          {
            fieldId: 'applicant[dateOfExpiry]',
            name: 'applicant[dateOfExpiry]',
            label: 'Passport expiry date',
            minDate: true,
            type: 'date',
            format: 'YYYY-MM-DD',
          },
          {
            fieldId: 'applicant[dateOfIssue]',
            name: 'applicant[dateOfIssue]',
            label: 'Passport issued date',
            maxDate: true,
            type: 'date',
            format: 'YYYY-MM-DD',
          },
          {
            fieldId: 'application[residentialStatusInUK]',
            required: true,
            name: 'application[residentialStatusInUK]',
            label: 'Residential status in UK',
            type: 'select',
            options: [
              {
                label: 'UK Citizen',
                value: 'UK Citizen',
              },
              {
                label: 'British Citizen',
                value: 'British Citizen',
              },
              {
                label: 'British Overseas Territories',
                value: 'British Overseas Territories',
              },
              {
                label: 'EU national with settled status',
                value: 'EU national with settled status',
              },
              {
                label: 'Refugee',
                value: 'Refugee',
              },
              {
                label: 'Humanitarian protection',
                value: 'Humanitarian protection',
              },
              {
                label: 'Settled in the UK',
                value: 'Settled in the UK',
              },
              {
                label: 'I will need a visa to study',
                value: 'I will need a visa to study',
              },
              {
                label: 'Other',
                value: 'Other',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'application[residentialStatusOther]',
            required: true,
            name: 'application[residentialStatusOther]',
            label: 'If other (please specify)',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[residentialStatusInUK]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
          },
        ],
      },
      {
        sectionName: 'Permanent Address',
        subSectionName: '',
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            name: 'addresses[0]',
            type: 'address',
            options: [
              {
                fieldId: 'mailingCountry',
                required: true,
                name: 'mailingCountry',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'mailingState',
                required: true,
                name: 'mailingState',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
              {
                fieldId: 'mailingDistrict',
                required: true,
                name: 'mailingDistrict',
                label: 'City/Town',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
            ],
          },
          {
            fieldId: 'addresses[0][defaultAddress]',
            required: true,
            name: 'addresses[0][defaultAddress]',
            label: 'First Line',
            type: 'input',
            validationType: 'alphaAddress',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
          },
          {
            fieldId: 'addresses[0][addressLine2]',
            name: 'addresses[0][addressLine2]',
            label: 'Second Line',
            type: 'input',
            validationType: 'alphaAddress',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
          },
          {
            fieldId: 'addresses[0][mailingPostalCode]',
            required: true,
            name: 'addresses[0][mailingPostalCode]',
            label: 'Pin/Post/Zip Code',
            type: 'input',
            validationType: 'alphaNumeric',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 4,
                message: 'This field cannot be less than 4 characters',
              },
              maxLength: {
                value: 10,
                message: 'This field cannot be more than 10 characters',
              },
              pattern: {
                value: '',
                message: 'Please Input a valid Zipcode',
              },
            },
          },
        ],
      },
      {
        sectionName: 'Current Address',
        subSectionName: '',
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'addresses[0][isPermanentAddressSame]',
            required: true,
            name: 'addresses[0][isPermanentAddressSame]',
            label: 'Is your current address same as permanent address?',
            type: 'select',
            options: [
              {
                label: 'Yes',
                value: 'true',
              },
              {
                label: 'No',
                value: 'false',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              gridType: 'fullRow',
            },
          },
          {
            name: 'addresses[1]',
            type: 'address',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'addresses[0][isPermanentAddressSame]',
                expectedValue: 'false',
                type: 'LEAF',
              },
            },
            options: [
              {
                fieldId: 'mailingCountry',
                required: true,
                name: 'mailingCountry',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'mailingState',
                required: true,
                name: 'mailingState',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
              {
                fieldId: 'mailingDistrict',
                required: true,
                name: 'mailingDistrict',
                label: 'City/Town',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
            ],
          },
          {
            fieldId: 'addresses[1][defaultAddress]',
            required: true,
            name: 'addresses[1][defaultAddress]',
            label: 'First Line',
            type: 'input',
            validationType: 'alphaAddress',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'addresses[0][isPermanentAddressSame]',
                expectedValue: 'false',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'addresses[1][addressLine2]',
            name: 'addresses[1][addressLine2]',
            label: 'Second Line',
            type: 'input',
            validationType: 'alphaAddress',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'addresses[0][isPermanentAddressSame]',
                expectedValue: 'false',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'addresses[1][mailingPostalCode]',
            required: true,
            name: 'addresses[1][mailingPostalCode]',
            label: 'Pin/Post/Zip Code',
            type: 'input',
            validationType: 'alphaNumeric',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 4,
                message: 'This field cannot be less than 4 characters',
              },
              maxLength: {
                value: 10,
                message: 'This field cannot be more than 10 characters',
              },
              pattern: {
                value: '',
                message: 'Please Input a valid Zipcode',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'addresses[0][isPermanentAddressSame]',
                expectedValue: 'false',
                type: 'LEAF',
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'familyInfo',
    stepName: 'Monitoring Information',
    showStepName: false,
    stepVisible: true,
    stepType: 'form',
    sections: [
      {
        sectionId: 'familyInformation',
        sectionName: 'Monitoring Information',
        subSectionName: '',
        instructionList: [
          'The information you provide below will help us monitor application in line with our equality, diversity and inclusion policies',
          'If you declare that you have a disability or other need, we will use this information to provide reasonable adjustments at interview and may reach out to you with information about our support for students with disabilities.',
          'If you declare that you are care experienced we may reach out to you to provide you with offers of additional support',
          'None of the information below will be used in the selection process.',
        ],
        sectionPosition: 2,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'applicant[qualification]',
            required: true,
            name: 'applicant[qualification]',
            instruction:
              "The following question is about your parents' level of education. This includes natural parents, adoptive parents, step-parents or guardians who have brought you up.",
            label:
              '1. Do any of your parents (as defined above) have any higher education qualifications, such as a degree, diploma or certificate of higher education?',
            type: 'select',
            ui: {
              gridType: 'fullRow',
            },
            options: [
              {
                label: 'Information refused',
                value: 'Information refused',
              },
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
              {
                label: "Don't know",
                value: "Don't know",
              },
            ],
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid First Name',
              },
            },
          },
          {
            fieldId: 'applicant[ethnicity]',
            required: true,
            name: 'applicant[ethnicity]',
            label: '2. Ethnicity',
            type: 'select',
            options: [],
            ui: {
              gridType: 'fullRow',
            },
            validations: {
              required: 'This field is required',
            },
            metaData: {
              optionsKey: 'ethnicity',
            },
          },
          {
            fieldId: 'applicant[haveYouBeenInCare]',
            required: true,
            name: 'applicant[haveYouBeenInCare]',
            instructionList: [
              "If you have spent any time living in public care as a looked after child, including: in local authority care and living with foster carers or in a children's home, being 'looked after' at home under a home supervision order in Scotland, please select Yes",
              'If you have not spent time in care, please select No',
            ],
            helperText:
              'Please note this does not refer to time spent working in a care or healthcare setting or if you are or have been a carer for a relative.',
            label: '3. Have you been in care ?',
            type: 'select',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
              {
                label: 'Prefer not to say',
                value: 'Prefer not to say',
              },
            ],
            ui: {
              gridType: 'fullRow',
            },
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'applicant[parentOccupation]',
            name: 'applicant[parentOccupation]',
            label:
              '4. If you are under 21, please give the occupation of your parent, step-parent or guardian who earns the most. If he or she is retired or unemployed, give their most recent occupation. If you are 21 or over, please give your own occupation.',
            type: 'select',
            ui: {
              gridType: 'fullRow',
            },
            options: [],
            metaData: {
              optionsKey: 'parentOccupation',
            },
            validations: {
              required: 'Field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid First Name',
              },
            },
          },
          {
            fieldId: 'applicant[latestOccupation]',
            name: 'applicant[latestOccupation]',
            label: 'Please specify your occupation',
            type: 'input',
            validationType: 'alphaNumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[parentOccupation]',
                expectedValue: ['Retired', 'Unemployed'],
                type: 'LEAF',
              },
            },
            ui: {
              gridType: 'fullRow',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
          },
          {
            fieldId: 'applicant[doYouHaveImpairment]',
            required: true,
            name: 'applicant[doYouHaveImpairment]',
            label:
              '5. Do you have an impairment, health condition or learning difference that has a substantial or long term impact on your ability to carry out day to day activities?',
            type: 'select',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
              {
                label: 'Prefer not to say',
                value: 'Prefer not to say',
              },
            ],
            ui: {
              gridType: 'fullRow',
            },
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'applicant[specialAbilityDetails]',
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[doYouHaveImpairment]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            ui: {
              gridType: 'fullRow',
            },
            type: 'multiSelectII',
            options: [],
            metaData: {
              optionsKey: 'disablity',
            },
            name: 'applicant[specialAbilityDetails]',
            label: 'Please share details',
            validations: {
              required: 'This field is required',
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'basic Details',
    stepName: 'Employment',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        sectionId: 'employmentDetails',
        sectionName: 'Employment Details',
        subSectionName: '',
        sectionPosition: 3,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'workExperiences',
            name: 'workExperiences',
            label: 'Work Experiences',
            type: 'array',
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
              removeMultiple: false,
            },
            fieldsArray: [
              {
                fieldId: 'jobType',
                name: 'jobType',
                label: 'Job Type',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                type: 'select',
                options: [
                  {
                    label: 'Full Time',
                    value: 'Full Time',
                  },
                  {
                    label: 'Part Time',
                    value: 'Part Time',
                  },
                  {
                    label: 'Internship',
                    value: 'Internship',
                  },
                ],
              },
              {
                fieldId: 'organisationName',
                name: 'organisationName',
                label: 'Company',
                type: 'input',
                required: true,
                options: [],
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                  maxLength: {
                    value: 200,
                    message: 'This field cannot be more than 200 characters',
                  },
                },
              },
              {
                fieldId: 'companyOthers',
                name: 'companyOthers',
                label: 'Company Other',
                type: 'input',
                required: true,
                options: [],
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                  maxLength: {
                    value: 200,
                    message: 'This field cannot be more than 200 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'organisationName',
                    expectedValue: 'Other',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'industryType',
                name: 'industryType',
                label: 'Industry Type',
                type: 'select',
                required: true,
                options: [],
                metaData: {
                  optionsKey: 'industryType',
                },
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'industryTypeOthers',
                name: 'industryTypeOthers',
                label: 'Industry Type Other',
                type: 'input',
                required: true,
                options: [],
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 100,
                    message: 'This field cannot be more than 100 characters',
                  },
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'industryType',
                    expectedValue: 'Other',
                    type: 'LEAF',
                  },
                },
              },
              {
                name: '',
                type: 'address',
                options: [
                  {
                    fieldId: 'country',
                    required: true,
                    name: 'country',
                    isPartOfCollection: true,
                    label: 'Country',
                    type: 'select',
                    validations: {
                      required: 'This field is required',
                    },
                  },
                  {
                    fieldId: 'state',
                    required: true,
                    name: 'state',
                    label: 'State',
                    type: 'select',
                    validations: {
                      required: 'This field is required',
                    },
                    options: [],
                  },
                  {
                    fieldId: 'city',
                    required: true,
                    name: 'city',
                    label: 'City/Town',
                    type: 'select',
                    validations: {
                      required: 'This field is required',
                    },
                    options: [],
                  },
                ],
              },
              {
                fieldId: 'location',
                name: 'location',
                label: 'Work Address',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                },
              },
              {
                fieldId: 'designation',
                name: 'designation',
                label: 'Job Title',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                },
              },
              {
                fieldId: 'roles',
                name: 'roles',
                label: 'Roles',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                },
              },
              {
                fieldId: 'dateOfJoining',
                name: 'dateOfJoining',
                label: 'Date Of Joining',
                type: 'date',
                format: 'YYYY-MM-DD',
                required: true,
                fieldValidation: {
                  scope: 'dateOfLeaving',
                  value: 'SMALLER',
                },
                validations: {
                  required: 'This field is required',
                },
                minDate: 50,
                maxDate: true,
              },
              {
                fieldId: 'workingInCompany',
                name: 'workingInCompany',
                label: 'Is it your current company?',
                type: 'select',
                options: [
                  {
                    label: 'Yes',
                    value: 'true',
                  },
                  {
                    label: 'No',
                    value: 'false',
                  },
                ],
                required: true,
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'dateOfLeaving',
                name: 'dateOfLeaving',
                label: 'Date Of Leaving',
                type: 'date',
                required: true,
                format: 'YYYY-MM-DD',
                fieldValidation: {
                  scope: 'dateOfJoining',
                  value: 'GREATER',
                },
                maxDate: true,
                validations: {
                  required: 'This field is required',
                },
                rule: {
                  effect: 'SHOW',
                  condition: {
                    scope: 'workingInCompany',
                    expectedValue: 'false',
                    type: 'LEAF',
                  },
                },
              },
              {
                fieldId: 'currencyType',
                name: 'currencyType',
                label: 'Currency Type',
                type: 'select',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                options: [],
                metaData: {
                  optionsKey: 'currency',
                },
              },
              {
                fieldId: 'annualSalary',
                name: 'annualSalary',
                label: 'Annual Salary',
                type: 'input',
                validationType: 'numberWithDecimal',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value',
                  },
                  maxLength: {
                    value: 15,
                    message: 'This field cannot be more than 15 characters',
                  },
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    stepId: 'basic Details',
    stepName: 'Education',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        apiKeyId: '',
        sectionName: 'Education Details',
        sectionId: 'educationHistories[0]',
        subSectionName: 'Postgraduate Details',
        sectionPosition: 1,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'educationHistories[0][doHavePGDegree]',
            name: 'educationHistories[0][doHavePGDegree]',
            label: 'Do you have a post graduation degree ?',
            type: 'select',
            required: true,
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'educationHistories[0][resultAnnounced]',
            name: 'educationHistories[0][resultAnnounced]',
            required: true,
            label: 'Result Announced ?',
            type: 'select',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][yearOfPassing]',
            name: 'educationHistories[0][yearOfPassing]',
            label: 'Year of completion',
            type: 'date',
            views: ['month', 'year'],
            format: 'MMMM, YYYY',
            maxDate: true,
            minDate: 50,
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            required: true,
          },
          {
            fieldId: 'educationHistories[0][institutionName]',
            name: 'educationHistories[0][institutionName]',
            label: 'University/Institution',
            required: true,
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][universityOthers]',
            name: 'educationHistories[0][universityOthers]',
            label: 'University/Institution Other',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][institutionName]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][placeOfStudy]',
            name: 'educationHistories[0][placeOfStudy]',
            label: 'College',
            type: 'input',
            validations: {
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][educationType]',
            name: 'educationHistories[0][educationType]',
            label: 'Education Type',
            type: 'select',
            options: [
              {
                label: 'Full time',
                value: 'Full time',
              },
              {
                label: 'Part time',
                value: 'Part time',
              },
              {
                label: 'Distance',
                value: 'Distance',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][degreeEarned]',
            name: 'educationHistories[0][degreeEarned]',
            label: 'Degree',
            metaData: {
              optionsKey: 'degreePg',
            },
            type: 'select',
            options: [],
            validations: {
              required: 'This field is required',
            },
            required: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][otherDegree]',
            name: 'educationHistories[0][otherDegree]',
            label: 'Degree Other',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][degreeEarned]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][degreeEarned]': 'Other',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][degreeCGPADGPA]',
            name: 'educationHistories[0][degreeCGPADGPA]',
            required: true,
            label: 'Evaluation Type',
            type: 'select',
            options: [
              {
                label: 'CGPA',
                value: 'CGPA',
              },
              {
                label: 'GPA',
                value: 'GPA',
              },
              {
                label: 'Grade',
                value: 'Grade',
              },
              {
                label: 'Percentage',
                value: 'Percentage',
              },
              {
                label: 'Points',
                value: 'Points',
              },
              {
                label: 'Classification',
                value: 'Classification',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][britishClassificationValues]',
            name: 'educationHistories[0][britishClassificationValues]',
            required: true,
            label: 'British undergraduate degree classification',
            type: 'select',
            options: [
              {
                label: 'Distinction',
                value: 'Distinction',
              },
              {
                label: 'First-Class Honours',
                value: 'First-Class Honours',
              },
              {
                label: 'Upper Second-Class Honours',
                value: 'Upper Second-Class Honours',
              },
              {
                label: 'Lower Second-Class Honours',
                value: 'Lower Second-Class Honours',
              },
              {
                label: 'Third-Class Honours',
                value: 'Third-Class Honours',
              },
              {
                label: 'Fail',
                value: 'Fail',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][degreeCGPADGPA]',
                expectedValue: 'Classification',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][obtainedMarks]',
            required: true,
            name: 'educationHistories[0][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[0][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'Yes',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][obtainedMarks]',
            required: true,
            name: 'educationHistories[0][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'Yes',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][obtainedMarks]',
            required: true,
            name: 'educationHistories[0][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'Yes',
                  'educationHistories[0][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][obtainedMarks]',
            name: 'educationHistories[0][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[0][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'No',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][obtainedMarks]',
            name: 'educationHistories[0][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'No',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][obtainedMarks]',
            name: 'educationHistories[0][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'No',
                  'educationHistories[0][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[0][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[0][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'Yes',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[0][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[0][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'Yes',
                  'educationHistories[0][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[0][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'Yes',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][totalAttainableMarks]',
            name: 'educationHistories[0][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[0][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'No',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][totalAttainableMarks]',
            name: 'educationHistories[0][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[0][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'No',
                  'educationHistories[0][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[0][totalAttainableMarks]',
            name: 'educationHistories[0][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][resultAnnounced]',
                  'educationHistories[0][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[0][resultAnnounced]': 'No',
                  'educationHistories[0][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            name: 'educationHistories[0]',
            type: 'address',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            options: [
              {
                fieldId: 'country',
                required: true,
                name: 'country',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'state',
                required: true,
                name: 'state',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
              {
                fieldId: 'city',
                required: true,
                name: 'city',
                label: 'City/Town',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
            ],
          },
        ],
      },
      {
        apiKeyId: '',
        sectionName: '',
        summarySection: 'UnderGraduate Degree',
        sectionId: 'educationHistories[1]',
        subSectionName: 'Undergraduate Degree',
        sectionPosition: 1,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'educationHistories[1][resultAnnounced]',
            name: 'educationHistories[1][resultAnnounced]',
            required: true,
            label: 'Result Announced ?',
            type: 'select',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[0][doHavePGDegree]',
                expectedValue: 'No',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][yearOfPassing]',
            name: 'educationHistories[1][yearOfPassing]',
            label: 'Year of completion',
            type: 'date',
            views: ['month', 'year'],
            format: 'MMMM, YYYY',
            validations: {
              required: 'This field is required',
            },
            required: true,
            maxDate: true,
            minDate: 50,
          },
          {
            fieldId: 'educationHistories[1][institutionName]',
            name: 'educationHistories[1][institutionName]',
            label: 'University/Institution',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][universityOthers]',
            name: 'educationHistories[1][universityOthers]',
            label: 'University/Institution Other',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[1][institutionName]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][placeOfStudy]',
            name: 'educationHistories[1][placeOfStudy]',
            label: 'College',
            type: 'input',
            validations: {
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][educationType]',
            name: 'educationHistories[1][educationType]',
            label: 'Education Type',
            type: 'select',
            options: [
              {
                label: 'Full time',
                value: 'Full time',
              },
              {
                label: 'Part time',
                value: 'Part time',
              },
              {
                label: 'Distance',
                value: 'Distance',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            required: true,
          },
          {
            fieldId: 'educationHistories[1][degreeEarned]',
            name: 'educationHistories[1][degreeEarned]',
            label: 'Degree',
            type: 'select',
            metaData: {
              optionsKey: 'degree',
            },
            options: [],
            validations: {
              required: 'This field is required',
            },
            required: true,
          },
          {
            fieldId: 'educationHistories[1][otherDegree]',
            name: 'educationHistories[1][otherDegree]',
            label: 'Degree Other',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[1][degreeEarned]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][specialization]',
            required: true,
            name: 'educationHistories[1][specialization]',
            label: 'Graduation Specialization',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot be more than 80 characters',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][degreeCGPADGPA]',
            name: 'educationHistories[1][degreeCGPADGPA]',
            required: true,
            label: 'Evaluation Type',
            type: 'select',
            options: [
              {
                label: 'CGPA',
                value: 'CGPA',
              },
              {
                label: 'GPA',
                value: 'GPA',
              },
              {
                label: 'Grade',
                value: 'Grade',
              },
              {
                label: 'Percentage',
                value: 'Percentage',
              },
              {
                label: 'Points',
                value: 'Points',
              },
              {
                label: 'Classification',
                value: 'Classification',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'educationHistories[1][britishClassificationValues]',
            name: 'educationHistories[1][britishClassificationValues]',
            required: true,
            label: 'Classification',
            type: 'select',
            options: [
              {
                label: 'Distinction',
                value: 'Distinction',
              },
              {
                label: 'First-Class Honours',
                value: 'First-Class Honours',
              },
              {
                label: 'Upper Second-Class Honours',
                value: 'Upper Second-Class Honours',
              },
              {
                label: 'Lower Second-Class Honours',
                value: 'Lower Second-Class Honours',
              },
              {
                label: 'Third-Class Honours',
                value: 'Third-Class Honours',
              },
              {
                label: 'Fail',
                value: 'Fail',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[1][degreeCGPADGPA]',
                expectedValue: 'Classification',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            required: true,
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][doHavePGDegree]',
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[1][resultAnnounced]': 'Yes',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'No',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            required: true,
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][doHavePGDegree]',
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': 'No',
                  'educationHistories[1][resultAnnounced]': 'Yes',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            required: true,
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][doHavePGDegree]',
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[1][resultAnnounced]': 'Yes',
                  'educationHistories[1][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'No',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            required: true,
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[1][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            required: true,
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[1][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            required: true,
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[1][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]'
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': "No",
                  'educationHistories[1][resultAnnounced]': 'No',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]'
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': "No",
                  'educationHistories[1][resultAnnounced]': 'No',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][obtainedMarks]',
            name: 'educationHistories[1][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]'
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': "No",
                  'educationHistories[1][resultAnnounced]': 'No',
                  'educationHistories[1][degreeCGPADGPA]': ['CGPA'],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][doHavePGDegree]',
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': 'No',
                  'educationHistories[1][resultAnnounced]': 'Yes',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][doHavePGDegree]',
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': 'No',
                  'educationHistories[1][resultAnnounced]': 'Yes',
                  'educationHistories[1][degreeCGPADGPA]': ['CGPA'],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[0][doHavePGDegree]',
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[0][doHavePGDegree]': 'No',
                  'educationHistories[1][resultAnnounced]': 'Yes',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[1][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                ],
                expectedValue: {
                  'educationHistories[1][degreeCGPADGPA]': 'CGPA',
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[1][degreeCGPADGPA]',
                  'educationHistories[0][doHavePGDegree]',
                  "educationHistories[0][doHavePGDegree]"
                ],
                expectedValue: {
                  'educationHistories[1][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                  'educationHistories[0][doHavePGDegree]': 'Yes',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                  "educationHistories[0][doHavePGDegree]"
                ],
                expectedValue: {
                  "educationHistories[0][doHavePGDegree]": "No",
                  'educationHistories[1][resultAnnounced]': 'No',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[1][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a numeric value.',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                  "educationHistories[0][doHavePGDegree]"
                ],
                expectedValue: {
                  "educationHistories[0][doHavePGDegree]": "No",
                  'educationHistories[1][resultAnnounced]': 'No',
                  'educationHistories[1][degreeCGPADGPA]': ['CGPA'],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[1][totalAttainableMarks]',
            name: 'educationHistories[1][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[1][resultAnnounced]',
                  'educationHistories[1][degreeCGPADGPA]',
                  "educationHistories[0][doHavePGDegree]"
                ],
                expectedValue: {
                  "educationHistories[0][doHavePGDegree]": "No",
                  'educationHistories[1][resultAnnounced]': 'No',
                  'educationHistories[1][degreeCGPADGPA]': [
                    'Grade',
                    'Classification',
                  ],
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            name: 'educationHistories[1]',
            type: 'address',
            options: [
              {
                fieldId: 'country',
                required: true,
                name: 'country',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'state',
                required: true,
                name: 'state',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
              {
                fieldId: 'city',
                required: true,
                name: 'city',
                label: 'City/Town',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
            ],
          },
        ],
      },
      {
        sectionId: 'educationHistories[2]',
        sectionName: '',
        summarySection: 'A levels (or equivalent)',
        subSectionName: 'A levels (or equivalent)',
        sectionPosition: 5,
        sectionVisible: true,
        mergePrevMobile: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'educationHistories[2][educationType]',
            name: 'educationHistories[2][educationType]',
            required: true,
            label: 'Education Type',
            type: 'select',
            options: [
              {
                label: 'Full time',
                value: 'Full time',
              },
              {
                label: 'Part time',
                value: 'Part time',
              },
              {
                label: 'Distance',
                value: 'Distance',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'educationHistories[2][boardCouncil]',
            name: 'educationHistories[2][boardCouncil]',
            required: true,
            label: 'Board',
            type: 'select',
            metaData: {
              optionsKey: 'board12',
            },
            options: [],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'educationHistories[2][subjectMarks]',
            name: 'educationHistories[2][subjectMarks]',
            label: 'Subject Marks',
            type: 'array',
            divider: false,
            heading:
              'Add the subjects studied and the respective scores obtained',
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 6,
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[2][boardCouncil]',
                expectedValue:
                  'GCE A Levels/BTEC- Business and Technology Education Council',
                type: 'LEAF',
              },
            },
            fieldsArray: [
              {
                fieldId: 'subjectName',
                name: 'subjectName',
                label: 'Subject Name',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 100,
                    message: 'This field cannot be more than 100 characters',
                  },
                },
                type: 'input',
              },
              {
                fieldId: 'subjectScore',
                name: 'subjectScore',
                label: 'Subject Score',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 6,
                    message: 'This field cannot be more than 6 digits',
                  },
                },
                type: 'input',
              },
            ],
          },
          {
            fieldId: 'educationHistories[2][boardOthers]',
            name: 'educationHistories[2][boardOthers]',
            label: 'Board Other',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value.',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[2][boardCouncil]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][degreeCGPADGPA]',
            name: 'educationHistories[2][degreeCGPADGPA]',
            required: true,
            label: 'Evaluation Type',
            type: 'select',
            options: [
              {
                label: 'CGPA',
                value: 'CGPA',
              },
              {
                label: 'GPA',
                value: 'GPA',
              },
              {
                label: 'Grade',
                value: 'Grade',
              },
              {
                label: 'Percentage',
                value: 'Percentage',
              },
              {
                label: 'Points',
                value: 'Points',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[2][boardCouncil]',
                expectedValue: [
                  'IB- International Baccalaureate',
                  'IGCSE- International General Certificate of Secondary Education',
                  'CBSE- Central Board of Secondary Education',
                  'ICSE- Indian Certificate of Secondary Education',
                  'ISC- Indian School Certificate',
                  'NIOS- National Institute of Open Schooling',
                  'State Board',
                  'Other',
                ],
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][obtainedMarks]',
            required: true,
            name: 'educationHistories[2][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[2][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[2][boardCouncil]',
                  'educationHistories[2][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[2][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'IGCSE- International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[2][degreeCGPADGPA]': 'CGPA',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][obtainedMarks]',
            required: true,
            name: 'educationHistories[2][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[2][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[2][boardCouncil]',
                  'educationHistories[2][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[2][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'IGCSE- International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[2][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][obtainedMarks]',
            required: true,
            name: 'educationHistories[2][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[2][boardCouncil]',
                  'educationHistories[2][degreeCGPADGPA]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[2][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'IGCSE- International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[2][degreeCGPADGPA]': 'Grade',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[2][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[2][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[2][boardCouncil]',
                  'educationHistories[2][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[2][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'IGCSE- International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[2][degreeCGPADGPA]': 'CGPA',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[2][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[2][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[2][boardCouncil]',
                  'educationHistories[2][degreeCGPADGPA]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[2][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'IGCSE- International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[2][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[2][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[2][boardCouncil]',
                  'educationHistories[2][degreeCGPADGPA]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[2][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'IGCSE- International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[2][degreeCGPADGPA]': 'Grade',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[2][yearOfPassing]',
            required: true,
            name: 'educationHistories[2][yearOfPassing]',
            label: 'Completion year',
            type: 'date',
            views: ['month', 'year'],
            format: 'MMMM, YYYY',
            maxDate: true,
            minDate: 50,
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'educationHistories[2][placeOfStudy]',
            required: true,
            name: 'educationHistories[2][placeOfStudy]',
            label: 'Institute Name',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                message: 'This field cannot be more than 200 characters',
                value: 200,
              },
            },
          },
          {
            name: 'educationHistories[2]',
            type: 'address',
            options: [
              {
                fieldId: 'country',
                required: true,
                name: 'country',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'state',
                required: true,
                name: 'state',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
              {
                fieldId: 'city',
                required: true,
                name: 'city',
                label: 'City/Town',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
            ],
          },
        ],
      },
      {
        sectionId: 'educationHistories[3]',
        sectionName: '',
        summarySection: 'GCSE’s (or equivalent)',
        subSectionName: 'GCSE’s (or equivalent)',
        sectionPosition: 5,
        sectionVisible: true,
        mergePrevMobile: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'educationHistories[3][educationType]',
            name: 'educationHistories[3][educationType]',
            required: true,
            label: 'Education Type',
            type: 'select',
            options: [
              {
                label: 'Full time',
                value: 'Full time',
              },
              {
                label: 'Part time',
                value: 'Part time',
              },
              {
                label: 'Distance',
                value: 'Distance',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'educationHistories[3][boardCouncil]',
            name: 'educationHistories[3][boardCouncil]',
            required: true,
            label: 'Board',
            type: 'select',
            metaData: {
              optionsKey: 'board10',
            },
            options: [],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'educationHistories[3][subjectMarks]',
            name: 'educationHistories[3][subjectMarks]',
            label: 'Subject Marks',
            type: 'array',
            divider: false,
            heading:
              'Add the subjects studied and the respective scores obtained',
            metaData: {
              addMultiple: true,
              minItems: 2,
              maxLimit: 6,
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[3][boardCouncil]',
                expectedValue:
                  'GCSE- General Certificate of Secondary Education',
                type: 'LEAF',
              },
            },
            fieldsArray: [
              {
                fieldId: 'subjectName',
                name: 'subjectName',
                label: 'Subject Name',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 100,
                    message: 'This field cannot be more than 100 characters',
                  },
                },
                type: 'input',
              },
              {
                fieldId: 'subjectScore',
                name: 'subjectScore',
                label: 'Subject Score',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 6,
                    message: 'This field cannot be more than 6 digits',
                  },
                },
                type: 'input',
              },
            ],
          },
          {
            fieldId: 'educationHistories[3][boardOthers]',
            name: 'educationHistories[3][boardOthers]',
            label: 'Board Other',
            type: 'input',
            required: true,
            options: [],
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value.',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'educationHistories[3][boardCouncil]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][degreeCGPADGPA]',
            name: 'educationHistories[3][degreeCGPADGPA]',
            required: true,
            label: 'Evaluation Type',
            type: 'select',
            options: [
              {
                label: 'CGPA',
                value: 'CGPA',
              },
              {
                label: 'GPA',
                value: 'GPA',
              },
              {
                label: 'Grade',
                value: 'Grade',
              },
              {
                label: 'Percentage',
                value: 'Percentage',
              },
              {
                label: 'Points',
                value: 'Points',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            rule: {
              effect: 'HIDE',
              condition: {
                scope: 'educationHistories[3][boardCouncil]',
                expectedValue:
                  'GCSE- General Certificate of Secondary Education',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][obtainedMarks]',
            required: true,
            name: 'educationHistories[3][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[3][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[3][boardCouncil]',
                  'educationHistories[3][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[3][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[3][degreeCGPADGPA]': 'CGPA',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][obtainedMarks]',
            required: true,
            name: 'educationHistories[3][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[3][totalAttainableMarks]',
              rule: 'LESSER',
              message: 'This field should not be grater than total marks',
            },
            type: 'input',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                every: true,
                scope: [
                  'educationHistories[3][boardCouncil]',
                  'educationHistories[3][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[3][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[3][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][obtainedMarks]',
            required: true,
            name: 'educationHistories[3][obtainedMarks]',
            label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[3][boardCouncil]',
                  'educationHistories[3][degreeCGPADGPA]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[3][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[3][degreeCGPADGPA]': 'Grade',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[3][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[3][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 10,
                message: 'This field should not be greater than 10',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[3][boardCouncil]',
                  'educationHistories[3][degreeCGPADGPA]',
                ],
                expectedValue: {
                  'educationHistories[3][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[3][degreeCGPADGPA]': 'CGPA',
                },
                every: true,
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[3][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'numberWithDecimal',
            validateField: {
              scope: 'educationHistories[3][obtainedMarks]',
              rule: 'GREATER',
              message: 'This field should not be lesser than obtained marks',
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'This is not a valid value',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[3][boardCouncil]',
                  'educationHistories[3][degreeCGPADGPA]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[3][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[3][degreeCGPADGPA]': [
                    'GPA',
                    'Percentage',
                    'Points',
                  ],
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][totalAttainableMarks]',
            required: true,
            name: 'educationHistories[3][totalAttainableMarks]',
            label: 'Total CGPA/GPA/Grade/Percentage/Points',
            type: 'input',
            validationType: 'gradeII',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 3,
                message: 'This field cannot be more than 3 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: [
                  'educationHistories[3][boardCouncil]',
                  'educationHistories[3][degreeCGPADGPA]',
                ],
                every: true,
                expectedValue: {
                  'educationHistories[3][boardCouncil]': [
                    'IB- International Baccalaureate',
                    'International General Certificate of Secondary Education',
                    'CBSE- Central Board of Secondary Education',
                    'ICSE- Indian Certificate of Secondary Education',
                    'ISC- Indian School Certificate',
                    'NIOS- National Institute of Open Schooling',
                    'State Board',
                    'Other',
                  ],
                  'educationHistories[3][degreeCGPADGPA]': 'Grade',
                },
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'educationHistories[3][yearOfPassing]',
            required: true,
            name: 'educationHistories[3][yearOfPassing]',
            label: 'Completion year',
            type: 'date',
            views: ['month', 'year'],
            format: 'MMMM, YYYY',
            maxDate: true,
            minDate: 50,
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'educationHistories[3][placeOfStudy]',
            required: true,
            name: 'educationHistories[3][placeOfStudy]',
            label: 'Institute Name',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            name: 'educationHistories[3]',
            type: 'address',
            options: [
              {
                fieldId: 'country',
                required: true,
                name: 'country',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'state',
                required: true,
                name: 'state',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
              {
                fieldId: 'city',
                required: true,
                name: 'city',
                label: 'City/Town',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
              },
            ],
          },
        ],
      },
      {
        sectionId: 'additionCertificateDetails',
        sectionName: 'Additional Qualification Details',
        subSectionName: '',
        sectionPosition: 3,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[doYouHaveCertificate]',
            name: 'application[doYouHaveCertificate]',
            required: true,
            label:
              'Can you provide any details on your additional skills or qualifications?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              gridType: 'fullRow',
            },
          },
          {
            fieldId: 'certifications',
            name: 'certifications',
            label: 'Additional Qualification Details',
            type: 'array',
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 10,
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[doYouHaveCertificate]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            fieldsArray: [
              {
                fieldId: 'name',
                name: 'name',
                label: 'Certificate Name',
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                },
                type: 'input',
              },
              {
                fieldId: 'completionYear',
                name: 'completionYear',
                label: 'Completion year',
                maxDate: true,
                required: true,
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                },
                type: 'date',
                views: ['month', 'year'],
                format: 'MMMM, YYYY',
              },
              {
                fieldId: 'educationType',
                name: 'educationType',
                label: 'Education Type',
                required: true,
                options: [
                  {
                    label: 'Full time',
                    value: 'Full time',
                  },
                  {
                    label: 'Part time',
                    value: 'Part time',
                  },
                  {
                    label: 'Online',
                    value: 'Online',
                  },
                ],
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value.',
                  },
                },
                type: 'select',
              },
              {
                fieldId: 'institute',
                name: 'institute',
                label: 'Organisation',
                type: 'input',
                required: true,
                validations: {
                  required: 'This field is required',
                  maxLength: {
                    value: 80,
                    message: 'This field cannot be more than 80 characters',
                  },
                },
              },
              {
                name: '',
                type: 'address',
                options: [
                  {
                    fieldId: 'country',
                    required: true,
                    name: 'country',
                    isPartOfCollection: true,
                    label: 'Country',
                    type: 'select',
                    validations: {
                      required: 'This field is required',
                    },
                  },
                  {
                    fieldId: 'state',
                    required: true,
                    name: 'state',
                    label: 'State',
                    type: 'select',
                    validations: {
                      required: 'This field is required',
                    },
                    options: [],
                  },
                  {
                    fieldId: 'city',
                    required: true,
                    name: 'city',
                    label: 'City/Town',
                    type: 'select',
                    validations: {
                      required: 'This field is required',
                    },
                    options: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    stepId: 'basic Details',
    stepName: 'Other',
    showStepName: false,
    stepVisible: true,
    stepPosition: 1,
    stepType: 'form',
    sections: [
      {
        sectionId: 'otherInfo',
        sectionName: 'Other Information',
        subSectionName: '',
        sectionPosition: 6,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[sportsAchievements]',
            name: 'application[sportsAchievements]',
            label: 'Sporting Achievements',
            type: 'textArea',
            remaining: true,
            maxCharacters: 500,
            validationType: 'alphaNumeric',
            ui: {
              gridType: 'fullRow',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                message: 'This field cannot be more than 500 characters',
                value: 500,
              },
            },
          },
          {
            fieldId: 'application[professionalAchievements]',
            name: 'application[professionalAchievements]',
            label: 'Professional Achievements',
            type: 'textArea',
            remaining: true,
            maxCharacters: 500,
            validationType: 'alphaNumeric',
            ui: {
              gridType: 'fullRow',
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                message: 'This field cannot be more than 500 characters',
                value: 500,
              },
            },
          },
          {
            fieldId: 'application[extraCurricularActivities]',
            name: 'application[extraCurricularActivities]',
            label:
              'Extra Curricular Activities (social, political, personal etc)',
            type: 'textArea',
            remaining: true,
            maxCharacters: 500,
            ui: {
              gridType: 'fullRow',
            },
            validationType: 'alphaNumeric',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                message: 'This field cannot be more than 500 characters',
                value: 500,
              },
            },
          },
          {
            fieldId: 'application[exceptionalAcademicAchievements]',
            name: 'application[exceptionalAcademicAchievements]',
            label: 'Exceptional Academic Achievements',
            type: 'textArea',
            remaining: true,
            maxCharacters: 500,
            ui: {
              gridType: 'fullRow',
            },
            validationType: 'alphaNumeric',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                message: 'This field cannot be more than 500 characters',
                value: 500,
              },
            },
          },
          {
            fieldId: 'application[howDoYouPlanToFundYourEducation]',
            required: true,
            name: 'application[howDoYouPlanToFundYourEducation]',
            label: 'How do you plan to fund your education?',
            type: 'select',
            options: [
              {
                label: 'Self-funding',
                value: 'Self-funding',
              },
              {
                label: 'Student Loan Company',
                value: 'Student Loan Company',
              },
              {
                label: 'Other',
                value: 'Other',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'application[fundDetails]',
            required: true,
            name: 'application[fundDetails]',
            label: 'Please specify your fund details',
            maxCharacters: 500,
            ui: {
              gridType: 'fullRow',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[howDoYouPlanToFundYourEducation]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                message: 'This field cannot be more than 500 characters',
                value: 500,
              },
            },
          },
          {
            fieldId: 'applicant[specifyRequirements]',
            required: false,
            name: 'applicant[specifyRequirements]',
            label: 'Please specify the requirements',
            type: 'textArea',
            remaining: true,
            maxCharacters: 500,
            ui: {
              gridType: 'fullRow',
            },
            validationType: 'alphaNumeric',
            validations: {
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                message: 'This field cannot be more than 500 characters',
                value: 500,
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[needReasonableAdjustments]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
          },
          {
            fieldId: 'application[mastersPlan]',
            required: true,
            name: 'application[mastersPlan]',
            label: 'What are you planning to do after your degree in SP Jain?',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 200,
                message: 'This field cannot be more than 200 characters',
              },
            },
          },
          {
            fieldId: 'application[companySponsorship]',
            required: true,
            name: 'application[companySponsorship]',
            label: 'Are you sponsored by your company?',
            validations: {
              required: 'This field is required',
            },
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
          {
            fieldId: 'application[statementOfPurpose]',
            required: true,
            name: 'application[statementOfPurpose]',
            label: 'Please provide your personal statement',
            helperText:
              'You may also share the link to your open statement of purpose (SOP).',
            type: 'textArea',
            remaining: true,
            ui: {
              gridType: 'fullRow',
            },
            maxCharacters: 10000,
            validationType: 'alphaNumeric',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                message: 'This field cannot be more than 10000 characters',
                value: 10000,
              },
            },
          },
        ],
      },
      {
        sectionId: 'entranceExams',
        sectionName: 'Aptitude Test Score Details',
        subSectionName: '',
        sectionPosition: 6,
        sectionVisible: true,
        mergePrevMobile: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[entrance]',
            name: 'application[entrance]',
            required: true,
            validations: {
              required: 'This field is required',
            },
            label: 'Have you gone through any aptitude test',
            type: 'select',
            ui: {
              gridType: 'fullRow',
            },
            options: [
              {
                label: 'Yes',
                value: 'true',
              },
              {
                label: 'No',
                value: 'false',
              },
            ],
          },
          {
            fieldId: 'entranceExams',
            name: 'entranceExams',
            label: '',
            type: 'array',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[entrance]',
                expectedValue: 'true',
                type: 'LEAF',
              },
            },
            metaData: {
              addMultiple: true,
              minItems: 1,
              maxLimit: 6,
            },
            fieldsArray: [
              {
                fieldId: 'selectExam',
                name: 'selectExam',
                label: 'Test Type',
                required: true,
                validations: {
                  required: 'This field is required',
                },
                type: 'select',
                options: [
                  {
                    label: 'CAT',
                    value: 'CAT',
                  },
                  {
                    label: 'SPJAT',
                    value: 'SPJAT',
                  },
                  {
                    label: 'GMAT',
                    value: 'GMAT',
                  },
                  {
                    label: 'GRE',
                    value: 'GRE',
                  },
                ],
              },
              {
                fieldId: 'registrationNumber',
                name: 'registrationNumber',
                label: 'Registration Number',
                type: 'input',
                required: true,
                validationType: 'alphaNumeric',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value',
                  },
                  maxLength: {
                    value: 40,
                    message: 'This field cannot be more than 40 characters',
                  },
                },
              },
              {
                fieldId: 'dateOfExam',
                name: 'dateOfExam',
                label: 'Date of Exam',
                type: 'date',
                minDate: 5,
                format: 'YYYY-MM-DD',
                maxDate: true,
                required: true,
                validations: {
                  required: 'This field is required',
                },
              },
              {
                fieldId: 'score',
                name: 'score',
                label: 'Score',
                type: 'input',
                required: true,
                validationType: 'numberWithDecimal',
                validations: {
                  required: 'This field is required',
                  pattern: {
                    value: '',
                    message: 'Please input a correct value',
                  },
                  min: {
                    value: 1,
                    message: 'This field should not be lesser than 1',
                  },
                  max: {
                    value: 100,
                    message: 'This field should not be greater than 100',
                  },
                  maxLength: {
                    value: 6,
                    message: 'This field cannot be more than 6 characters',
                  },
                },
              },
            ],
          },
        ],
      },
      {
        sectionId: 'entranceExamsEnglish',
        sectionName: 'English Test results',
        subSectionName: '',
        sectionPosition: 6,
        sectionVisible: true,
        mergePrevMobile: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[doYouHaveIELTScertificate]',
            name: 'application[doYouHaveIELTScertificate]',
            required: true,
            validations: {
              required: 'This field is required',
            },
            label:
              'Do you have an English test result taken within the last two years? (If Yes, a field will be added upload results)',
            helperText:
              "English test qualification is not a mandatory requirement for UK applicants. Kindly select 'No', if you are UK applicant.",
            type: 'select',
            ui: {
              gridType: 'fullRow',
            },
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
          {
            fieldId: 'englishTests[0][registrationNumber]',
            name: 'englishTests[0][registrationNumber]',
            label: 'Registration Number',
            type: 'input',
            required: true,
            validationType: 'alphaNumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[doYouHaveIELTScertificate]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              maxLength: {
                value: 40,
                message: 'This field cannot be more than 40 characters',
              },
            },
          },
          {
            fieldId: 'englishTests[0][dateOfExam]',
            name: 'englishTests[0][dateOfExam]',
            label: 'Date of Exam',
            type: 'date',
            maxDate: true,
            minDate: 5,
            required: true,
            format: 'YYYY-MM-DD',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[doYouHaveIELTScertificate]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'englishTests[0][score]',
            name: 'englishTests[0][score]',
            label: 'Score',
            type: 'input',
            required: true,
            validationType: 'numberWithDecimal',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[doYouHaveIELTScertificate]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a correct value',
              },
              min: {
                value: 1,
                message: 'This field should not be lesser than 1',
              },
              max: {
                value: 100,
                message: 'This field should not be greater than 100',
              },
              maxLength: {
                value: 6,
                message: 'This field cannot be more than 6 characters',
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'references',
        sectionName: 'References',
        subSectionName: '',
        sectionPosition: 8,
        sectionVisible: true,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'application[appliedFromAnywhere]',
            name: 'application[appliedFromAnywhere]',
            required: true,
            label:
              'Have you applied to S P Jain-Dubai/Mumbai/Singapore/Sydney in the past?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: 'true',
              },
              {
                label: 'No',
                value: 'false',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[pastBatch]',
            required: true,
            name: 'application[pastBatch]',
            label: 'Batch',
            type: 'select',
            metaData: {
              optionsKey: 'batch',
            },
            options: [],
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[appliedFromAnywhere]',
                expectedValue: 'true',
                type: 'LEAF',
              },
            },
            validationType: 'number',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please input a valid Batch',
              },
              maxLength: {
                value: 4,
                message: 'This field cannot be more than 4 characters.',
              },
            },
          },
          {
            fieldId: 'application[educationalConsultantReferral]',
            required: true,
            name: 'application[educationalConsultantReferral]',
            label: 'Were you referred by Education Consultant of SP Jain?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
            },
          },
          {
            fieldId: 'application[consultantName]',
            required: true,
            name: 'application[consultantName]',
            label: 'Consultant Name',
            type: 'input',
            conditional: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[educationalConsultantReferral]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot have more than 80 characters',
              },
            },
          },
          {
            fieldId: 'application[howDidYouHearAboutSPJain]',
            required: true,
            name: 'application[howDidYouHearAboutSPJain]',
            label: 'How did you hear about SP Jain?',
            type: 'select',
            options: [
              {
                label: 'Alumnus of SP Jain',
                value: 'Alumnus of SP Jain',
              },
              {
                label: 'EDM Invite',
                value: 'EDM Invite',
              },
              {
                label: 'Email Promotion',
                value: 'Email Promotion',
              },
              {
                label: 'Info Session',
                value: 'Info Session',
              },
              {
                label: 'Newpaper / Magazine Article or Advertisement',
                value: 'Newpaper / Magazine Article or Advertisement',
              },
              {
                label: 'Online Search',
                value: 'Online Search',
              },
              {
                label: 'SP Jain Representative',
                value: 'SP Jain Representative',
              },
              {
                label: 'SP Jain Website',
                value: 'SP Jain Website',
              },
              {
                label: 'Social Media',
                value: 'Social Media',
              },
              {
                label: 'TV / Radio',
                value: 'TV / Radio',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[wereYouReferredByAlumniReferral]',
            required: true,
            name: 'application[wereYouReferredByAlumniReferral]',
            label: 'Were you referred by Alumnus or Active student',
            apiKey: 'application[wereYouReferredByAlumniReferral]',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 6,
              },
            },
          },
          {
            fieldId: 'application[alumniStudent]',
            required: true,
            name: 'application[alumniStudent]',
            label: 'Alumni/Student Name',
            type: 'input',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[wereYouReferredByAlumniReferral]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 80,
                message: 'This field cannot have more than 80 characters',
              },
            },
          },
          {
            fieldId: 'application[entranceExamPrep]',
            required: true,
            name: 'application[entranceExamPrep]',
            label: 'Are you preparing for any other entrance examination?',
            type: 'select',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid Value',
              },
            },
          },
          {
            fieldId: 'application[nameOfEntranceTest]',
            required: true,
            name: 'application[nameOfEntranceTest]',
            label:
              "Can you, please share Name of Entrance Test and your Training Institute if any? (Please note this question is just for research purpose and won't have any impact on your application)",
            type: 'input',
            ui: {
              gridType: 'fullRow',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[entranceExamPrep]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please Input a valid Value',
              },
              maxLength: {
                value: 200,
                message: 'This field cannot be less than 200 characters',
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'documentUpload',
    stepName: 'Document Upload',
    showStepName: false,
    stepVisible: true,
    stepPosition: 0,
    stepType: 'documents',
    sections: [
      {
        sectionId: 'documentUpload',
        sectionName: 'Document Upload',
        subSectionName: '',
        sectionPosition: 6,
        sectionVisible: true,
        sectionType: 'form',
        fields: [],
      },
    ],
  },
  {
    stepId: 'declaration',
    stepName: 'Declaration',
    stepPosition: 5,
    showStepName: true,
    stepVisible: true,
    stepType: 'declaration',
    voucher: true,
    sections: [],
  },
  {
    stepId: 'summaryWithDeclaration',
    stepName: 'Summary',
    stepPosition: 5,
    showStepName: true,
    stepVisible: true,
    stepType: 'summary',
    voucher: true,
    sections: [],
  },
];

// UG
// export const defaultJson = [
//   {
//     stepId: 'Course Details',
//     stepName: 'Course Details',
//     showStepName: false,
//     stepVisible: true,
//     stepPosition: 0,
//     stepType: 'form',
//     sections: [
//       {
//         apiKeyId: 'application',
//         sectionId: 'ProgramDetails2',
//         sectionName: 'Course Details',
//         subSectionName: '',
//         showSectionName: false,
//         sectionPosition: 2,
//         sectionVisible: true,
//         sectionHelp: '',
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'application[programName]',
//             name: 'application[programName]',
//             label: 'Program',
//             type: 'input',
//             options: [],
//             disabled: true,
//             apiKey: 'Program',
//             validationType: 'string',
//             validations: [],
//             ui: {
//               gridType: 'halfRow',
//             },
//           },
//           {
//             fieldId: 'application[academicYear]',
//             name: 'application[academicYear]',
//             label: 'Academic Cycle',
//             type: 'input',
//             apiKey: 'application[academicYear]',
//             validations: [],
//             disabled: true,
//             ui: {
//               gridType: 'halfRow',
//             },
//           },
//         ],
//       },
//     ],
//   },
//   {
//     stepId: 'basic Details',
//     stepName: 'Basic Details',
//     showStepName: false,
//     stepVisible: true,
//     stepPosition: 1,
//     stepType: 'form',
//     sections: [
//       {
//         sectionName: 'Basic Details',
//         apiKeyId: 'applicant',
//         subSectionName: '',
//         sectionPosition: 1,
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'applicant[firstName]',
//             required: true,
//             name: 'applicant[firstName]',
//             label: 'First Name',
//             type: 'input',
//             validationType: 'alpha',
//             disabled: true,
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid First Name',
//               },
//               maxLength: {
//                 value: 40,
//                 message: 'This field cannot be more than 40 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[middleName]',
//             name: 'applicant[middleName]',
//             label: 'Middle Name',
//             disabled: true,
//             type: 'input',
//             validationType: 'alpha',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid First Name',
//               },
//               maxLength: {
//                 value: 40,
//                 message: 'This field cannot be more than 40 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[lastName]',
//             required: true,
//             name: 'applicant[lastName]',
//             label: 'Last Name',
//             disabled: true,
//             validationType: 'lastName',
//             type: 'input',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid Last Name',
//               },
//               maxLength: {
//                 value: 40,
//                 message: 'This field cannot be more than 40 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[dateOfBirth]',
//             required: true,
//             name: 'applicant[dateOfBirth]',
//             label: 'Date of Birth',
//             type: 'date',
//             validations: {
//               required: 'This field is required',
//             },
//             format: 'YYYY-MM-DD',
//             maxDate: -16,
//           },
//           {
//             fieldId: 'applicant[gender]',
//             required: true,
//             name: 'applicant[gender]',
//             label: 'Gender',
//             type: 'select',
//             options: [
//               {
//                 value: 'Female',
//                 label: 'Female',
//               },
//               {
//                 value: 'Male',
//                 label: 'Male',
//               },
//               {
//                 value: 'Decline to State',
//                 label: 'Decline to State',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[genderIdentity]',
//             required: true,
//             name: 'applicant[genderIdentity]',
//             label: 'Gender Identity',
//             type: 'select',
//             options: [
//               {
//                 value: 'Male',
//                 label: 'Male',
//               },
//               {
//                 value: 'Female',
//                 label: 'Female',
//               },
//               {
//                 value: 'Nonbinary',
//                 label: 'Nonbinary',
//               },
//               {
//                 value: 'Not Listed',
//                 label: 'Not Listed',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[pronouns]',
//             required: true,
//             name: 'applicant[pronouns]',
//             label: 'Gender Pronouns',
//             type: 'select',
//             options: [
//               {
//                 value: 'He',
//                 label: 'He',
//               },
//               {
//                 value: 'She',
//                 label: 'She',
//               },
//               {
//                 value: 'They',
//                 label: 'They',
//               },
//               {
//                 value: 'Prefer not to say',
//                 label: 'Prefer not to say',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[nationality]',
//             required: true,
//             name: 'applicant[nationality]',
//             label: 'Nationality',
//             type: 'select',
//             metaData: {
//               optionsKey: 'nationality',
//             },
//             options: [],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[phone]',
//             required: true,
//             name: 'applicant[phone]',
//             label: 'Phone Number',
//             type: 'phone',
//             apiKey: 'applicant[phone]',
//             disabled: true,
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: {},
//                 message: 'Please Input a valid Phone Number',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[email]',
//             required: true,
//             name: 'applicant[email]',
//             label: 'Email',
//             disabled: true,
//             type: 'input',
//             validationType: 'email',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid Email',
//               },
//             },
//           },
//           {
//             name: 'applicant',
//             type: 'address',
//             options: [
//               {
//                 fieldId: 'birthPlace',
//                 required: true,
//                 name: 'birthPlace',
//                 label: 'Country of birth',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//               },
//             ],
//           },
//           {
//             fieldId: 'applicant[passportNumber]',
//             name: 'applicant[passportNumber]',
//             label: 'Passport number',
//             validationType: 'alphaNumeric',
//             type: 'input',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please enter a valid passport number',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 9 characters',
//                 value: 9,
//               },
//               minLength: {
//                 message: 'This field cannot be less than 6 characters',
//                 value: 6,
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[dateOfExpiry]',
//             name: 'applicant[dateOfExpiry]',
//             label: 'Passport expiry date',
//             minDate: true,
//             type: 'date',
//             format: 'YYYY-MM-DD',
//           },
//           {
//             fieldId: 'applicant[dateOfIssue]',
//             name: 'applicant[dateOfIssue]',
//             label: 'Passport issued date',
//             maxDate: true,
//             type: 'date',
//             format: 'YYYY-MM-DD',
//           },
//           {
//             fieldId: 'application[residentialStatusInUK]',
//             required: true,
//             name: 'application[residentialStatusInUK]',
//             label: 'Residential status in UK',
//             type: 'select',
//             options: [
//               {
//                 label: 'UK Citizen',
//                 value: 'UK Citizen',
//               },
//               {
//                 label: 'British Citizen',
//                 value: 'British Citizen',
//               },
//               {
//                 label: 'British Overseas Territories',
//                 value: 'British Overseas Territories',
//               },
//               {
//                 label: 'EU national with settled status',
//                 value: 'EU national with settled status',
//               },
//               {
//                 label: 'Refugee',
//                 value: 'Refugee',
//               },
//               {
//                 label: 'Humanitarian protection',
//                 value: 'Humanitarian protection',
//               },
//               {
//                 label: 'Settled in the UK',
//                 value: 'Settled in the UK',
//               },
//               {
//                 label: 'I will need a visa to study',
//                 value: 'I will need a visa to study',
//               },
//               {
//                 label: 'Other',
//                 value: 'Other',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'application[residentialStatusOther]',
//             required: true,
//             name: 'application[residentialStatusOther]',
//             label: 'If other (please specify)',
//             type: 'input',
//             validations: {
//               required: 'This field is required',
//               maxLength: {
//                 value: 100,
//                 message: 'This field cannot be more than 100 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[residentialStatusInUK]',
//                 expectedValue: 'Other',
//                 type: 'LEAF',
//               },
//             },
//           },
//         ],
//       },
//       {
//         sectionName: 'Permanent Address',
//         subSectionName: '',
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             name: 'addresses[0]',
//             type: 'address',
//             options: [
//               {
//                 fieldId: 'mailingCountry',
//                 required: true,
//                 name: 'mailingCountry',
//                 isPartOfCollection: true,
//                 label: 'Country',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//               },
//               {
//                 fieldId: 'mailingState',
//                 required: true,
//                 name: 'mailingState',
//                 label: 'State',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//               {
//                 fieldId: 'mailingDistrict',
//                 required: true,
//                 name: 'mailingDistrict',
//                 label: 'City/Town',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//             ],
//           },
//           {
//             fieldId: 'addresses[0][defaultAddress]',
//             required: true,
//             name: 'addresses[0][defaultAddress]',
//             label: 'First Line',
//             type: 'input',
//             validationType: 'alphaAddress',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'addresses[0][addressLine2]',
//             name: 'addresses[0][addressLine2]',
//             label: 'Second Line',
//             type: 'input',
//             validationType: 'alphaAddress',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'addresses[0][mailingPostalCode]',
//             required: true,
//             name: 'addresses[0][mailingPostalCode]',
//             label: 'Pin/Post/Zip Code',
//             type: 'input',
//             validationType: 'alphaNumeric',
//             validations: {
//               required: 'This field is required',
//               minLength: {
//                 value: 4,
//                 message: 'This field cannot be less than 4 characters',
//               },
//               maxLength: {
//                 value: 10,
//                 message: 'This field cannot be more than 10 characters',
//               },
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid Zipcode',
//               },
//             },
//           },
//         ],
//       },
//       {
//         sectionName: 'Current Address',
//         subSectionName: '',
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'addresses[0][isPermanentAddressSame]',
//             required: true,
//             name: 'addresses[0][isPermanentAddressSame]',
//             label: 'Is your current address same as permanent address?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'true',
//               },
//               {
//                 label: 'No',
//                 value: 'false',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               gridType: 'fullRow',
//             },
//           },
//           {
//             name: 'addresses[1]',
//             type: 'address',
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'addresses[0][isPermanentAddressSame]',
//                 expectedValue: 'false',
//                 type: 'LEAF',
//               },
//             },
//             options: [
//               {
//                 fieldId: 'mailingCountry',
//                 required: true,
//                 name: 'mailingCountry',
//                 isPartOfCollection: true,
//                 label: 'Country',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//               },
//               {
//                 fieldId: 'mailingState',
//                 required: true,
//                 name: 'mailingState',
//                 label: 'State',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//               {
//                 fieldId: 'mailingDistrict',
//                 required: true,
//                 name: 'mailingDistrict',
//                 label: 'City/Town',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//             ],
//           },
//           {
//             fieldId: 'addresses[1][defaultAddress]',
//             required: true,
//             name: 'addresses[1][defaultAddress]',
//             label: 'First Line',
//             type: 'input',
//             validationType: 'alphaAddress',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'addresses[0][isPermanentAddressSame]',
//                 expectedValue: 'false',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'addresses[1][addressLine2]',
//             name: 'addresses[1][addressLine2]',
//             label: 'Second Line',
//             type: 'input',
//             validationType: 'alphaAddress',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'addresses[0][isPermanentAddressSame]',
//                 expectedValue: 'false',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'addresses[1][mailingPostalCode]',
//             required: true,
//             name: 'addresses[1][mailingPostalCode]',
//             label: 'Pin/Post/Zip Code',
//             type: 'input',
//             validationType: 'alphaNumeric',
//             validations: {
//               required: 'This field is required',
//               minLength: {
//                 value: 4,
//                 message: 'This field cannot be less than 4 characters',
//               },
//               maxLength: {
//                 value: 10,
//                 message: 'This field cannot be more than 10 characters',
//               },
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid Zipcode',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'addresses[0][isPermanentAddressSame]',
//                 expectedValue: 'false',
//                 type: 'LEAF',
//               },
//             },
//           },
//         ],
//       },
//     ],
//   },
//   {
//     stepId: 'familyInfo',
//     stepName: 'Monitoring Information',
//     showStepName: false,
//     stepVisible: true,
//     stepType: 'form',
//     sections: [
//       {
//         sectionId: 'familyInformation',
//         sectionName: 'Monitoring Information',
//         subSectionName: '',
//         instructionList: [
//           'The information you provide below will help us monitor application in line with our equality, diversity and inclusion policies',
//           'If you declare that you have a disability or other need, we will use this information to provide reasonable adjustments at interview and may reach out to you with information about our support for students with disabilities.',
//           'If you declare that you are care experienced we may reach out to you to provide you with offers of additional support',
//           'None of the information below will be used in the selection process.',
//         ],
//         sectionPosition: 2,
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'applicant[qualification]',
//             required: true,
//             name: 'applicant[qualification]',
//             instruction:
//               "The following question is about your parents' level of education. This includes natural parents, adoptive parents, step-parents or guardians who have brought you up.",
//             label:
//               '1. Do any of your parents (as defined above) have any higher education qualifications, such as a degree, diploma or certificate of higher education?',
//             type: 'select',
//             ui: {
//               gridType: 'fullRow',
//             },
//             options: [
//               {
//                 label: 'Information refused',
//                 value: 'Information refused',
//               },
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//               {
//                 label: "Don't know",
//                 value: "Don't know",
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid First Name',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[ethnicity]',
//             required: true,
//             name: 'applicant[ethnicity]',
//             label: '2. Ethnicity',
//             type: 'select',
//             options: [],
//             ui: {
//               gridType: 'fullRow',
//             },
//             validations: {
//               required: 'This field is required',
//             },
//             metaData: {
//               optionsKey: 'ethnicity',
//             },
//           },
//           {
//             fieldId: 'applicant[haveYouBeenInCare]',
//             required: true,
//             name: 'applicant[haveYouBeenInCare]',
//             instructionList: [
//               "If you have spent any time living in public care as a looked after child, including: in local authority care and living with foster carers or in a children's home, being 'looked after' at home under a home supervision order in Scotland, please select Yes",
//               'If you have not spent time in care, please select No',
//             ],
//             helperText:
//               'Please note this does not refer to time spent working in a care or healthcare setting or if you are or have been a carer for a relative.',
//             label: '3. Have you been in care ?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//               {
//                 label: 'Prefer not to say',
//                 value: 'Prefer not to say',
//               },
//             ],
//             ui: {
//               gridType: 'fullRow',
//             },
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[parentOccupation]',
//             name: 'applicant[parentOccupation]',
//             label:
//               '4. If you are under 21, please give the occupation of your parent, step-parent or guardian who earns the most. If he or she is retired or unemployed, give their most recent occupation. If you are 21 or over, please give your own occupation.',
//             type: 'select',
//             ui: {
//               gridType: 'fullRow',
//             },
//             options: [],
//             metaData: {
//               optionsKey: 'parentOccupation',
//             },
//             validations: {
//               required: 'Field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid First Name',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[latestOccupation]',
//             name: 'applicant[latestOccupation]',
//             label: 'Please specify your occupation',
//             type: 'input',
//             validationType: 'alphaNumeric',
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'applicant[parentOccupation]',
//                 expectedValue: ['Retired', 'Unemployed'],
//                 type: 'LEAF',
//               },
//             },
//             ui: {
//               gridType: 'fullRow',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[doYouHaveImpairment]',
//             required: true,
//             name: 'applicant[doYouHaveImpairment]',
//             label:
//               '5. Do you have an impairment, health condition or learning difference that has a substantial or long term impact on your ability to carry out day to day activities?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//               {
//                 label: 'Prefer not to say',
//                 value: 'Prefer not to say',
//               },
//             ],
//             ui: {
//               gridType: 'fullRow',
//             },
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[specialAbilityDetails]',
//             required: true,
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'applicant[doYouHaveImpairment]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             ui: {
//               gridType: 'fullRow',
//             },
//             type: 'multiSelectII',
//             options: [],
//             metaData: {
//               optionsKey: 'disablity',
//             },
//             name: 'applicant[specialAbilityDetails]',
//             label: 'Please share details',
//             validations: {
//               required: 'This field is required',
//             },
//           },
//         ],
//       },
//     ],
//   },
//   {
//     stepId: 'basic Details',
//     stepName: 'Education',
//     showStepName: false,
//     stepVisible: true,
//     stepPosition: 1,
//     stepType: 'form',
//     sections: [
//       {
//         sectionId: 'educationHistories[0]',
//         sectionName: 'Education Details',
//         subSectionName: 'A levels (or equivalent)',
//         sectionPosition: 5,
//         sectionVisible: true,
//         mergePrevMobile: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'educationHistories[0][resultAnnounced]',
//             name: 'educationHistories[0][resultAnnounced]',
//             required: true,
//             label: 'Result Announced ?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][educationType]',
//             name: 'educationHistories[0][educationType]',
//             required: true,
//             label: 'Education Type',
//             type: 'select',
//             options: [
//               {
//                 label: 'Full time',
//                 value: 'Full time',
//               },
//               {
//                 label: 'Part time',
//                 value: 'Part time',
//               },
//               {
//                 label: 'Distance',
//                 value: 'Distance',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][boardCouncil]',
//             name: 'educationHistories[0][boardCouncil]',
//             required: true,
//             label: 'Board',
//             type: 'select',
//             metaData: {
//               optionsKey: 'board12',
//             },
//             options: [],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][subjectMarks]',
//             name: 'educationHistories[0][subjectMarks]',
//             label: 'Subject Marks',
//             type: 'array',
//             divider: false,
//             heading:
//               'Add the subjects studied and the respective scores obtained',
//             metaData: {
//               addMultiple: true,
//               minItems: 1,
//               maxLimit: 6,
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'educationHistories[0][boardCouncil]',
//                 expectedValue:
//                   'GCE A Levels/BTEC- Business and Technology Education Council',
//                 type: 'LEAF',
//               },
//             },
//             fieldsArray: [
//               {
//                 fieldId: 'subjectName',
//                 name: 'subjectName',
//                 label: 'Subject Name',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   maxLength: {
//                     value: 100,
//                     message: 'This field cannot be more than 100 characters',
//                   },
//                 },
//                 type: 'input',
//               },
//               {
//                 fieldId: 'subjectScore',
//                 name: 'subjectScore',
//                 label: 'Subject Score',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   maxLength: {
//                     value: 6,
//                     message: 'This field cannot be more than 6 digits',
//                   },
//                 },
//                 type: 'input',
//               },
//             ],
//           },
//           {
//             fieldId: 'educationHistories[0][boardOthers]',
//             name: 'educationHistories[0][boardOthers]',
//             label: 'Board Other',
//             type: 'input',
//             required: true,
//             options: [],
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value.',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'educationHistories[0][boardCouncil]',
//                 expectedValue: 'Other',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][degreeCGPADGPA]',
//             name: 'educationHistories[0][degreeCGPADGPA]',
//             required: true,
//             label: 'Evaluation Type',
//             type: 'select',
//             options: [
//               {
//                 label: 'CGPA',
//                 value: 'CGPA',
//               },
//               {
//                 label: 'GPA',
//                 value: 'GPA',
//               },
//               {
//                 label: 'Grade',
//                 value: 'Grade',
//               },
//               {
//                 label: 'Percentage',
//                 value: 'Percentage',
//               },
//               {
//                 label: 'Points',
//                 value: 'Points',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'educationHistories[0][boardCouncil]',
//                 expectedValue: [
//                   'IB- International Baccalaureate',
//                   'IGCSE- International General Certificate of Secondary Education',
//                   'CBSE- Central Board of Secondary Education',
//                   'ICSE- Indian Certificate of Secondary Education',
//                   'ISC- Indian School Certificate',
//                   'NIOS- National Institute of Open Schooling',
//                   'State Board',
//                   'Other',
//                 ],
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][obtainedMarks]',
//             required: true,
//             name: 'educationHistories[0][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[0][totalAttainableMarks]',
//               rule: 'LESSER',
//               message: 'This field should not be grater than total marks',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 every: true,
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'Yes',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'GPA',
//                     'Percentage',
//                     'Points',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][obtainedMarks]',
//             required: true,
//             name: 'educationHistories[0][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'gradeII',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 3,
//                 message: 'This field cannot be more than 3 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'Yes',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'Grade',
//                     'Classification',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][obtainedMarks]',
//             required: true,
//             name: 'educationHistories[0][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 10,
//                 message: 'This field should not be greater than 10',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'Yes',
//                   'educationHistories[0][degreeCGPADGPA]': 'CGPA',
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][obtainedMarks]',
//             name: 'educationHistories[0][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[0][totalAttainableMarks]',
//               rule: 'LESSER',
//               message: 'This field should not be grater than total marks',
//             },
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'No',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'GPA',
//                     'Percentage',
//                     'Points',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][obtainedMarks]',
//             name: 'educationHistories[0][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'gradeII',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 3,
//                 message: 'This field cannot be more than 3 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'No',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'Grade',
//                     'Classification',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][obtainedMarks]',
//             name: 'educationHistories[0][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 10,
//                 message: 'This field should not be greater than 10',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'No',
//                   'educationHistories[0][degreeCGPADGPA]': ['CGPA'],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][totalAttainableMarks]',
//             required: true,
//             name: 'educationHistories[0][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[0][obtainedMarks]',
//               rule: 'GREATER',
//               message: 'This field should not be lesser than obtained marks',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'Yes',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'GPA',
//                     'Percentage',
//                     'Points',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][totalAttainableMarks]',
//             required: true,
//             name: 'educationHistories[0][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[0][obtainedMarks]',
//               rule: 'GREATER',
//               message: 'This field should not be lesser than obtained marks',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 10,
//                 message: 'This field should not be greater than 10',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'Yes',
//                   'educationHistories[0][degreeCGPADGPA]': ['CGPA'],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][totalAttainableMarks]',
//             required: true,
//             name: 'educationHistories[0][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'gradeII',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 3,
//                 message: 'This field cannot be more than 3 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'Yes',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'Grade',
//                     'Classification',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][totalAttainableMarks]',
//             name: 'educationHistories[0][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[0][obtainedMarks]',
//               rule: 'GREATER',
//               message: 'This field should not be lesser than obtained marks',
//             },
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'No',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'GPA',
//                     'Percentage',
//                     'Points',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][totalAttainableMarks]',
//             name: 'educationHistories[0][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[0][obtainedMarks]',
//               rule: 'GREATER',
//               message: 'This field should not be lesser than obtained marks',
//             },
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 10,
//                 message: 'This field should not be greater than 10',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'No',
//                   'educationHistories[0][degreeCGPADGPA]': ['CGPA'],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][totalAttainableMarks]',
//             name: 'educationHistories[0][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'gradeII',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 3,
//                 message: 'This field cannot be more than 3 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[0][resultAnnounced]',
//                   'educationHistories[0][degreeCGPADGPA]',
//                   'educationHistories[0][boardCouncil]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[0][resultAnnounced]': 'No',
//                   'educationHistories[0][degreeCGPADGPA]': [
//                     'Grade',
//                     'Classification',
//                   ],
//                   'educationHistories[0][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'IGCSE- International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][yearOfPassing]',
//             required: true,
//             name: 'educationHistories[0][yearOfPassing]',
//             label: 'Completion year',
//             type: 'date',
//             views: ['month', 'year'],
//             format: 'MMMM, YYYY',
//             maxDate: true,
//             minDate: 50,
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               grid: {
//                 xs: 12,
//                 md: 6,
//                 lg: 6,
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[0][placeOfStudy]',
//             name: 'educationHistories[0][placeOfStudy]',
//             label: 'Institute Name',
//             required: true,
//             type: 'input',
//             validations: {
//               required: 'This field is required',
//               maxLength: {
//                 message: 'This field cannot be more than 200 characters',
//                 value: 200,
//               },
//             },
//           },
//           {
//             name: 'educationHistories[0]',
//             type: 'address',
//             options: [
//               {
//                 fieldId: 'country',
//                 required: true,
//                 name: 'country',
//                 isPartOfCollection: true,
//                 label: 'Country',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//               },
//               {
//                 fieldId: 'state',
//                 required: true,
//                 name: 'state',
//                 label: 'State',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//               {
//                 fieldId: 'city',
//                 required: true,
//                 name: 'city',
//                 label: 'City/Town',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//             ],
//           },
//         ],
//       },
//       {
//         sectionId: 'educationHistories[1]',
//         sectionName: '',
//         summarySection: 'GCSE’s (or equivalent)',
//         subSectionName: 'GCSE’s (or equivalent)',
//         sectionPosition: 5,
//         sectionVisible: true,
//         mergePrevMobile: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'educationHistories[1][educationType]',
//             name: 'educationHistories[1][educationType]',
//             required: true,
//             label: 'Education Type',
//             type: 'select',
//             options: [
//               {
//                 label: 'Full time',
//                 value: 'Full time',
//               },
//               {
//                 label: 'Part time',
//                 value: 'Part time',
//               },
//               {
//                 label: 'Distance',
//                 value: 'Distance',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][boardCouncil]',
//             name: 'educationHistories[1][boardCouncil]',
//             required: true,
//             label: 'Board',
//             type: 'select',
//             metaData: {
//               optionsKey: 'board10',
//             },
//             options: [],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][subjectMarks]',
//             name: 'educationHistories[1][subjectMarks]',
//             label: 'Subject Marks',
//             type: 'array',
//             divider: false,
//             heading:
//               'Add the subjects studied and the respective scores obtained',
//             metaData: {
//               addMultiple: true,
//               minItems: 2,
//               maxLimit: 6,
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'educationHistories[1][boardCouncil]',
//                 expectedValue:
//                   'GCSE- General Certificate of Secondary Education',
//                 type: 'LEAF',
//               },
//             },
//             fieldsArray: [
//               {
//                 fieldId: 'subjectName',
//                 name: 'subjectName',
//                 label: 'Subject Name',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   maxLength: {
//                     value: 100,
//                     message: 'This field cannot be more than 100 characters',
//                   },
//                 },
//                 type: 'input',
//               },
//               {
//                 fieldId: 'subjectScore',
//                 name: 'subjectScore',
//                 label: 'Subject Score',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   maxLength: {
//                     value: 6,
//                     message: 'This field cannot be more than 6 digits',
//                   },
//                 },
//                 type: 'input',
//               },
//             ],
//           },
//           {
//             fieldId: 'educationHistories[1][boardOthers]',
//             name: 'educationHistories[1][boardOthers]',
//             label: 'Board Other',
//             type: 'input',
//             required: true,
//             options: [],
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value.',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'educationHistories[1][boardCouncil]',
//                 expectedValue: 'Other',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][degreeCGPADGPA]',
//             name: 'educationHistories[1][degreeCGPADGPA]',
//             required: true,
//             label: 'Evaluation Type',
//             type: 'select',
//             options: [
//               {
//                 label: 'CGPA',
//                 value: 'CGPA',
//               },
//               {
//                 label: 'GPA',
//                 value: 'GPA',
//               },
//               {
//                 label: 'Grade',
//                 value: 'Grade',
//               },
//               {
//                 label: 'Percentage',
//                 value: 'Percentage',
//               },
//               {
//                 label: 'Points',
//                 value: 'Points',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             rule: {
//               effect: 'HIDE',
//               condition: {
//                 scope: 'educationHistories[1][boardCouncil]',
//                 expectedValue:
//                   'GCSE- General Certificate of Secondary Education',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][obtainedMarks]',
//             required: true,
//             name: 'educationHistories[1][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[1][totalAttainableMarks]',
//               rule: 'LESSER',
//               message: 'This field should not be grater than total marks',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[1][boardCouncil]',
//                   'educationHistories[1][degreeCGPADGPA]',
//                 ],
//                 every: true,
//                 expectedValue: {
//                   'educationHistories[1][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                   'educationHistories[1][degreeCGPADGPA]': [
//                     'GPA',
//                     'Percentage',
//                     'Points',
//                   ],
//                 },
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][obtainedMarks]',
//             required: true,
//             name: 'educationHistories[1][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'gradeII',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 3,
//                 message: 'This field cannot be more than 3 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[1][boardCouncil]',
//                   'educationHistories[1][degreeCGPADGPA]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[1][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                   'educationHistories[1][degreeCGPADGPA]': 'Grade',
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][obtainedMarks]',
//             required: true,
//             name: 'educationHistories[1][obtainedMarks]',
//             label: 'Obtained CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 10,
//                 message: 'This field should not be greater than 10',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[1][boardCouncil]',
//                   'educationHistories[1][degreeCGPADGPA]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[1][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                   'educationHistories[1][degreeCGPADGPA]': 'CGPA',
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][totalAttainableMarks]',
//             required: true,
//             name: 'educationHistories[1][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[1][obtainedMarks]',
//               rule: 'GREATER',
//               message: 'This field should not be lesser than obtained marks',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[1][boardCouncil]',
//                   'educationHistories[1][degreeCGPADGPA]',
//                 ],
//                 every: true,
//                 expectedValue: {
//                   'educationHistories[1][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                   'educationHistories[1][degreeCGPADGPA]': [
//                     'GPA',
//                     'Percentage',
//                     'Points',
//                   ],
//                 },
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][totalAttainableMarks]',
//             required: true,
//             name: 'educationHistories[1][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'gradeII',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 3,
//                 message: 'This field cannot be more than 3 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[1][boardCouncil]',
//                   'educationHistories[1][degreeCGPADGPA]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[1][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                   'educationHistories[1][degreeCGPADGPA]': 'Grade',
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][totalAttainableMarks]',
//             required: true,
//             name: 'educationHistories[1][totalAttainableMarks]',
//             label: 'Total CGPA/GPA/Grade/Percentage/Points',
//             type: 'input',
//             validationType: 'numberWithDecimal',
//             validateField: {
//               scope: 'educationHistories[1][obtainedMarks]',
//               rule: 'GREATER',
//               message: 'This field should not be lesser than obtained marks',
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a numeric value.',
//               },
//               max: {
//                 value: 10,
//                 message: 'This field should not be greater than 10',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters',
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: [
//                   'educationHistories[1][boardCouncil]',
//                   'educationHistories[1][degreeCGPADGPA]',
//                 ],
//                 expectedValue: {
//                   'educationHistories[1][boardCouncil]': [
//                     'IB- International Baccalaureate',
//                     'International General Certificate of Secondary Education',
//                     'CBSE- Central Board of Secondary Education',
//                     'ICSE- Indian Certificate of Secondary Education',
//                     'ISC- Indian School Certificate',
//                     'NIOS- National Institute of Open Schooling',
//                     'State Board',
//                     'Other',
//                   ],
//                   'educationHistories[1][degreeCGPADGPA]': 'CGPA',
//                 },
//                 every: true,
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][yearOfPassing]',
//             required: true,
//             name: 'educationHistories[1][yearOfPassing]',
//             label: 'Completion year',
//             type: 'date',
//             views: ['month', 'year'],
//             format: 'MMMM, YYYY',
//             maxDate: true,
//             minDate: 50,
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               grid: {
//                 xs: 12,
//                 md: 6,
//                 lg: 6,
//               },
//             },
//           },
//           {
//             fieldId: 'educationHistories[1][placeOfStudy]',
//             name: 'educationHistories[1][placeOfStudy]',
//             label: 'Institute Name',
//             required: true,
//             type: 'input',
//             validations: {
//               required: 'This field is required',
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//             ui: {
//               grid: {
//                 xs: 12,
//                 md: 6,
//                 lg: 6,
//               },
//             },
//           },
//           {
//             name: 'educationHistories[1]',
//             type: 'address',
//             options: [
//               {
//                 fieldId: 'country',
//                 required: true,
//                 name: 'country',
//                 isPartOfCollection: true,
//                 label: 'Country',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//               },
//               {
//                 fieldId: 'state',
//                 required: true,
//                 name: 'state',
//                 label: 'State',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//               {
//                 fieldId: 'city',
//                 required: true,
//                 name: 'city',
//                 label: 'City/Town',
//                 type: 'select',
//                 validations: {
//                   required: 'This field is required',
//                 },
//                 options: [],
//               },
//             ],
//           },
//         ],
//       },
//       {
//         sectionId: 'additionCertificateDetails',
//         sectionName: 'Additional Qualification Details',
//         subSectionName: '',
//         sectionPosition: 3,
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'application[doYouHaveCertificate]',
//             name: 'application[doYouHaveCertificate]',
//             required: true,
//             label: 'Do you have any additional qualifications?',
//             type: 'radio',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               gridType: 'fullRow',
//             },
//           },
//           {
//             fieldId: 'certifications',
//             name: 'certifications',
//             label: 'Additional Qualification Details',
//             type: 'array',
//             metaData: {
//               addMultiple: true,
//               minItems: 1,
//               maxLimit: 10,
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[doYouHaveCertificate]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             fieldsArray: [
//               {
//                 fieldId: 'name',
//                 name: 'name',
//                 label: 'Certificate Name',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   pattern: {
//                     value: '',
//                     message: 'Please input a correct value.',
//                   },
//                   maxLength: {
//                     value: 80,
//                     message: 'This field cannot be more than 80 characters',
//                   },
//                 },
//                 type: 'input',
//               },
//               {
//                 fieldId: 'completionYear',
//                 name: 'completionYear',
//                 label: 'Completion year',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   pattern: {
//                     value: '',
//                     message: 'Please input a correct value.',
//                   },
//                 },
//                 format: 'MMMM, YYYY',
//                 type: 'date',
//                 views: ['month', 'year'],
//                 maxDate: true,
//               },
//               {
//                 fieldId: 'educationType',
//                 name: 'educationType',
//                 label: 'Education Type',
//                 required: true,
//                 options: [
//                   {
//                     label: 'Full time',
//                     value: 'Full time',
//                   },
//                   {
//                     label: 'Part time',
//                     value: 'Part time',
//                   },
//                   {
//                     label: 'Online',
//                     value: 'Online',
//                   },
//                 ],
//                 validations: {
//                   required: 'This field is required',
//                   pattern: {
//                     value: '',
//                     message: 'Please input a correct value.',
//                   },
//                 },
//                 type: 'select',
//               },
//               {
//                 fieldId: 'institute',
//                 name: 'institute',
//                 label: 'Organisation',
//                 type: 'input',
//                 required: true,
//                 validations: {
//                   required: 'This field is required',
//                   pattern: {
//                     value: '',
//                     message: 'Please input a correct value.',
//                   },
//                   maxLength: {
//                     value: 200,
//                     message: 'This field cannot be more than 200 characters',
//                   },
//                 },
//               },
//               {
//                 name: '',
//                 type: 'address',
//                 options: [
//                   {
//                     fieldId: 'country',
//                     required: true,
//                     name: 'country',
//                     isPartOfCollection: true,
//                     label: 'Country',
//                     type: 'select',
//                     validations: {
//                       required: 'This field is required',
//                     },
//                   },
//                   {
//                     fieldId: 'state',
//                     required: true,
//                     name: 'state',
//                     label: 'State',
//                     type: 'select',
//                     validations: {
//                       required: 'This field is required',
//                     },
//                     options: [],
//                   },
//                   {
//                     fieldId: 'city',
//                     required: true,
//                     name: 'city',
//                     label: 'City/Town',
//                     type: 'select',
//                     validations: {
//                       required: 'This field is required',
//                     },
//                     options: [],
//                   },
//                 ],
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
//   {
//     stepId: 'basic Details',
//     stepName: 'Other',
//     showStepName: false,
//     stepVisible: true,
//     stepPosition: 1,
//     stepType: 'form',
//     sections: [
//       {
//         sectionId: 'otherInfo',
//         sectionName: 'Other Information',
//         subSectionName: '',
//         sectionPosition: 6,
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'application[sportsAchievements]',
//             name: 'application[sportsAchievements]',
//             label: 'Sporting Achievements',
//             type: 'textArea',
//             remaining: true,
//             maxCharacters: 500,
//             ui: {
//               gridType: 'fullRow',
//             },
//             validationType: 'alphaNumeric',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 500 characters',
//                 value: 500,
//               },
//             },
//           },
//           {
//             fieldId: 'application[professionalAchievements]',
//             name: 'application[professionalAchievements]',
//             label: 'Professional Achievements',
//             type: 'textArea',
//             remaining: true,
//             maxCharacters: 500,
//             ui: {
//               gridType: 'fullRow',
//             },
//             validationType: 'alphaNumeric',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 500 characters',
//                 value: 500,
//               },
//             },
//           },
//           {
//             fieldId: 'application[extraCurricularActivities]',
//             name: 'application[extraCurricularActivities]',
//             label:
//               'Extra Curricular Activities (social, political, personal etc)',
//             type: 'textArea',
//             remaining: true,
//             maxCharacters: 500,
//             ui: {
//               gridType: 'fullRow',
//             },
//             validationType: 'alphaNumeric',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 500 characters',
//                 value: 500,
//               },
//             },
//           },
//           {
//             fieldId: 'application[exceptionalAcademicAchievements]',
//             name: 'application[exceptionalAcademicAchievements]',
//             label: 'Exceptional Academic Achievements',
//             type: 'textArea',
//             remaining: true,
//             maxCharacters: 500,
//             ui: {
//               gridType: 'fullRow',
//             },
//             validationType: 'alphaNumeric',
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 500 characters',
//                 value: 500,
//               },
//             },
//           },
//           {
//             fieldId: 'application[howDoYouPlanToFundYourEducation]',
//             required: true,
//             name: 'application[howDoYouPlanToFundYourEducation]',
//             label: 'How do you plan to fund your education?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Self-funding',
//                 value: 'Self-funding',
//               },
//               {
//                 label: 'Student Loan Company',
//                 value: 'Student Loan Company',
//               },
//               {
//                 label: 'Other',
//                 value: 'Other',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'application[fundDetails]',
//             required: true,
//             name: 'application[fundDetails]',
//             label: 'Please specify your fund details',
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[howDoYouPlanToFundYourEducation]',
//                 expectedValue: 'Other',
//                 type: 'LEAF',
//               },
//             },
//             type: 'input',
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'applicant[needReasonableAdjustments]',
//             required: true,
//             name: 'applicant[needReasonableAdjustments]',
//             label:
//               'Do you need any reasonable adjustments to the application process?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'applicant[isDifferentlyAbled]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'applicant[specifyRequirements]',
//             required: false,
//             name: 'applicant[specifyRequirements]',
//             label: 'Please specify the requirements',
//             type: 'textArea',
//             remaining: true,
//             maxCharacters: 500,
//             validationType: 'alphaNumeric',
//             ui: {
//               gridType: 'fullRow',
//             },
//             validations: {
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 500 characters',
//                 value: 500,
//               },
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'applicant[needReasonableAdjustments]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//           },
//           {
//             fieldId: 'application[mastersPlan]',
//             required: true,
//             name: 'application[mastersPlan]',
//             label: 'What are you planning to do after your degree in SP Jain?',
//             type: 'input',
//             validations: {
//               required: 'This field is required',
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be more than 200 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'application[companySponsorship]',
//             required: true,
//             name: 'application[companySponsorship]',
//             label: 'Are you sponsored by your company?',
//             validations: {
//               required: 'This field is required',
//             },
//             type: 'radio',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//           },
//           {
//             fieldId: 'application[statementOfPurpose]',
//             required: true,
//             name: 'application[statementOfPurpose]',
//             label: 'Please provide your personal statement.',
//             helperText:
//               'You may also share the link to your open statement of purpose (SOP).',
//             type: 'textArea',
//             remaining: true,
//             ui: {
//               gridType: 'fullRow',
//             },
//             maxCharacters: 10000,
//             validationType: 'alphaNumeric',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 message: 'This field cannot be more than 10000 characters',
//                 value: 10000,
//               },
//             },
//           },
//         ],
//       },
//       {
//         sectionId: 'entranceExamsEnglish',
//         sectionName: 'English test results',
//         subSectionName: '',
//         sectionPosition: 6,
//         sectionVisible: true,
//         mergePrevMobile: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'application[doYouHaveIELTScertificate]',
//             name: 'application[doYouHaveIELTScertificate]',
//             required: true,
//             validations: {
//               required: 'This field is required',
//             },
//             label:
//               'Do you have an English test result taken within the last two years? (If Yes, a field will be added upload results)',
//             helperText:
//               "English test qualification is not a mandatory requirement for UK applicants. Kindly select 'No', if you are UK applicant.",
//             type: 'select',
//             ui: {
//               gridType: 'fullRow',
//             },
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//           },
//           {
//             fieldId: 'englishTests[0][registrationNumber]',
//             name: 'englishTests[0][registrationNumber]',
//             label: 'Test agency',
//             type: 'input',
//             required: true,
//             validationType: 'alphaNumeric',
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[doYouHaveIELTScertificate]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               maxLength: {
//                 value: 40,
//                 message: 'This field cannot be more than 40 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'englishTests[0][dateOfExam]',
//             name: 'englishTests[0][dateOfExam]',
//             label: 'Date of Exam',
//             type: 'date',
//             format: 'YYYY-MM-DD',
//             maxDate: true,
//             minDate: 5,
//             required: true,
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[doYouHaveIELTScertificate]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'englishTests[0][score]',
//             name: 'englishTests[0][score]',
//             label: 'Score',
//             type: 'input',
//             required: true,
//             validationType: 'numberWithDecimal',
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[doYouHaveIELTScertificate]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a correct value',
//               },
//               min: {
//                 value: 1,
//                 message: 'This field should not be lesser than 1',
//               },
//               max: {
//                 value: 100,
//                 message: 'This field should not be greater than 100',
//               },
//               maxLength: {
//                 value: 6,
//                 message: 'This field cannot be more than 6 characters',
//               },
//             },
//           },
//         ],
//       },
//       {
//         apiKeyId: 'application',
//         sectionId: 'references',
//         sectionName: 'References',
//         subSectionName: '',
//         sectionPosition: 8,
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [
//           {
//             fieldId: 'application[appliedFromAnywhere]',
//             name: 'application[appliedFromAnywhere]',
//             required: true,
//             label:
//               'Have you applied to S P Jain-Dubai/Mumbai/Singapore/Sydney in the past?',
//             type: 'radio',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'true',
//               },
//               {
//                 label: 'No',
//                 value: 'false',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               grid: {
//                 xs: 12,
//                 md: 6,
//                 lg: 6,
//               },
//             },
//           },
//           {
//             fieldId: 'application[pastBatch]',
//             required: true,
//             name: 'application[pastBatch]',
//             label: 'Batch',
//             type: 'select',
//             metaData: {
//               optionsKey: 'batch',
//             },
//             options: [],
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[appliedFromAnywhere]',
//                 expectedValue: 'true',
//                 type: 'LEAF',
//               },
//             },
//             validationType: 'number',
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please input a valid Batch',
//               },
//               maxLength: {
//                 value: 4,
//                 message: 'This field cannot be more than 4 characters.',
//               },
//             },
//           },
//           {
//             fieldId: 'application[educationalConsultantReferral]',
//             required: true,
//             name: 'application[educationalConsultantReferral]',
//             label: 'Were you referred by Education Consultant of SP Jain?',
//             type: 'radio',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//           },
//           {
//             fieldId: 'application[consultantName]',
//             required: true,
//             name: 'application[consultantName]',
//             label: 'Consultant Name',
//             type: 'input',
//             conditional: true,
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[educationalConsultantReferral]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             validations: {
//               required: 'This field is required',
//               maxLength: {
//                 value: 80,
//                 message: 'This field cannot have more than 80 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'application[howDidYouHearAboutSPJain]',
//             required: true,
//             name: 'application[howDidYouHearAboutSPJain]',
//             label: 'How did you hear about SP Jain?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Alumnus of SP Jain',
//                 value: 'Alumnus of SP Jain',
//               },
//               {
//                 label: 'EDM Invite',
//                 value: 'EDM Invite',
//               },
//               {
//                 label: 'Email Promotion',
//                 value: 'Email Promotion',
//               },
//               {
//                 label: 'Info Session',
//                 value: 'Info Session',
//               },
//               {
//                 label: 'Newpaper / Magazine Article or Advertisement',
//                 value: 'Newpaper / Magazine Article or Advertisement',
//               },
//               {
//                 label: 'Online Search',
//                 value: 'Online Search',
//               },
//               {
//                 label: 'SP Jain Representative',
//                 value: 'SP Jain Representative',
//               },
//               {
//                 label: 'SP Jain Website',
//                 value: 'SP Jain Website',
//               },
//               {
//                 label: 'Social Media',
//                 value: 'Social Media',
//               },
//               {
//                 label: 'TV / Radio',
//                 value: 'TV / Radio',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               grid: {
//                 xs: 12,
//                 md: 6,
//                 lg: 6,
//               },
//             },
//           },
//           {
//             fieldId: 'application[wereYouReferredByAlumniReferral]',
//             required: true,
//             name: 'application[wereYouReferredByAlumniReferral]',
//             label: 'Were you referred by Alumnus or Active student',
//             apiKey: 'application[wereYouReferredByAlumniReferral]',
//             type: 'radio',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//             },
//             ui: {
//               grid: {
//                 xs: 12,
//                 md: 6,
//                 lg: 6,
//               },
//             },
//           },
//           {
//             fieldId: 'application[alumniStudent]',
//             required: true,
//             name: 'application[alumniStudent]',
//             label: 'Alumni/Student Name',
//             type: 'input',
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[wereYouReferredByAlumniReferral]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             validations: {
//               required: 'This field is required',
//               maxLength: {
//                 value: 80,
//                 message: 'This field cannot have more than 80 characters',
//               },
//             },
//           },
//           {
//             fieldId: 'application[entranceExamPrep]',
//             required: true,
//             name: 'application[entranceExamPrep]',
//             label: 'Are you preparing for any other entrance examination?',
//             type: 'select',
//             options: [
//               {
//                 label: 'Yes',
//                 value: 'Yes',
//               },
//               {
//                 label: 'No',
//                 value: 'No',
//               },
//             ],
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid Value',
//               },
//             },
//           },
//           {
//             fieldId: 'application[nameOfEntranceTest]',
//             required: true,
//             name: 'application[nameOfEntranceTest]',
//             label:
//               "Can you, please share Name of Entrance Test and your Training Institute if any? (Please note this question is just for research purpose and won't have any impact on your application)",
//             type: 'input',
//             ui: {
//               gridType: 'fullRow',
//             },
//             rule: {
//               effect: 'SHOW',
//               condition: {
//                 scope: 'application[entranceExamPrep]',
//                 expectedValue: 'Yes',
//                 type: 'LEAF',
//               },
//             },
//             validations: {
//               required: 'This field is required',
//               pattern: {
//                 value: '',
//                 message: 'Please Input a valid Value',
//               },
//               maxLength: {
//                 value: 200,
//                 message: 'This field cannot be less than 200 characters',
//               },
//             },
//           },
//         ],
//       },
//     ],
//   },
//   {
//     stepId: 'documentUpload',
//     stepName: 'Document Upload',
//     showStepName: false,
//     stepVisible: true,
//     stepPosition: 0,
//     stepType: 'documents',
//     sections: [
//       {
//         sectionId: 'documentUpload',
//         sectionName: 'Document Upload',
//         subSectionName: '',
//         sectionPosition: 6,
//         sectionVisible: true,
//         sectionType: 'form',
//         fields: [],
//       },
//     ],
//   },
//   {
//     stepId: 'declaration',
//     stepName: 'Declaration',
//     stepPosition: 5,
//     showStepName: true,
//     stepVisible: true,
//     stepType: 'declaration',
//     voucher: true,
//     sections: [],
//   },
//   {
//     stepId: 'summaryWithDeclaration',
//     stepName: 'Summary',
//     stepPosition: 5,
//     showStepName: true,
//     stepVisible: true,
//     stepType: 'summary',
//     voucher: true,
//     sections: [],
//   },
// ];
